import { ToastController } from "ionic-angular";
import { Injector } from "@angular/core";




export abstract class Domanda_super {
  public toastCtrl: ToastController;
  
  constructor(injector: Injector){
    this.toastCtrl = injector.get(ToastController);
    
  }
  presentToast(text) {
    const toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'middle'
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/msteps/domanda_super.ts